import script from "./resultsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./resultsInfo.vue?vue&type=script&setup=true&lang=js"

import "./resultsInfo.vue?vue&type=style&index=0&id=6b24d9de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b24d9de"]])

export default __exports__